import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 適格請求書発行事業者 */
enum EligibleBillingProvider {
  target = 'TARGET',
  notTarget = 'NOT_TARGET',
}

const nameConfig = {
  target: new Map([[Locale.ja, '適格請求書発行事業者の対象']]),
  notTarget: new Map([[Locale.ja, '適格請求書発行事業者の対象外 ']]),
};

const toEnum = rawValueToEnum(EligibleBillingProvider, EligibleBillingProvider.target);
const toDisplay = enumToName(EligibleBillingProvider, nameConfig);
const toDisplayWithPrefix = enumToName(EligibleBillingProvider, nameConfig, { prefix: true });

export const eligibleBillingProvider = {
  enum: EligibleBillingProvider,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { EligibleBillingProvider };
